"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedSubscriptionResponseModelCurrency = void 0;
exports.ExtendedSubscriptionResponseModelCurrency = {
    Usd: "usd",
    Eur: "eur",
};
